// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1obyn","topBottomGutter":"Layout_topBottomGutter__22mS7"};